import {
    SYSTEMDASHBOARDSCREEN_LOAD,
    SYSTEMDASHBOARDSCREEN_UNLOAD,
    SYSTEMDASHBOARDSCREEN_SET,
} from '../../../actionDefinitions';
import { createReducer } from '../../../reducerUtils';

const initialState =
{
    //Basic data
    //domainValues

    //Overall page
    //ticketCountOverTimeStats
    //jibeProgressOverTimeStats
    //responseOverTimeStats

    //Breakdowns
    //ticketCountOverTimeByBreakdownStats
    //responseBreakdownOverTimeStats
    //ticketCountOverTimeStats

    //reasonsForContact
    //userTeamsStats

    //jibeProgressOverTimeStats:
    //[
    //    {
    //        "questionCode": "ASAT",
    //        "overalSuccessRatePercent": 76,
    //        "aggregationName": null,
    //        "aggregationId": 0,
    //        "surveyCnt": 0,
    //        "sessionCnt": 0,
    //        "dateIndex": 1,
    //        "windowStart": "02/12/2024 00:00:00"
    //    },
    //    {
    //        "questionCode": "CSAT",
    //        "overalSuccessRatePercent": 71,
    //        "aggregationName": null,
    //        "aggregationId": 0,
    //        "surveyCnt": 0,
    //        "sessionCnt": 0,
    //        "dateIndex": 1,
    //        "windowStart": "02/12/2024 00:00:00"
    //    },
    //    {
    //        "questionCode": "ASAT",
    //        "overalSuccessRatePercent": 76,
    //        "aggregationName": null,
    //        "aggregationId": 0,
    //        "surveyCnt": 0,
    //        "sessionCnt": 0,
    //        "dateIndex": 2,
    //        "windowStart": "02/19/2024 00:00:00"
    //    },
    //    {
    //        "questionCode": "CSAT",
    //        "overalSuccessRatePercent": 71,
    //        "aggregationName": null,
    //        "aggregationId": 0,
    //        "surveyCnt": 0,
    //        "sessionCnt": 0,
    //        "dateIndex": 2,
    //        "windowStart": "02/19/2024 00:00:00"
    //    },
    //]

    //responseOverTimeStats:
    //[
    //    //    //For Each finalResponse, for questionCode, for each dateIndex

    //    //    //DateIndex: 5
    //    {
    //        "questionCode": "CSAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "No",
    //        "effectiveResponseCntRounded": 885,
    //        "sumQuestionEffectiveResponses": 2662,
    //        "customerResponseCnt": 131,
    //        "sumCustomerResponses": 474,
    //        "dateIndex": 5,
    //        "windowStart": "04/08/2024 00:00:00",
    //        "aggregationId": 0,
    //        "aggregationName": null
    //    },
    //    {
    //        "questionCode": "CSAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "Yes",
    //        "effectiveResponseCntRounded": 1777,
    //        "sumQuestionEffectiveResponses": 2662,
    //        "customerResponseCnt": 343,
    //        "sumCustomerResponses": 474,
    //        "dateIndex": 5,
    //        "windowStart": "04/08/2024 00:00:00",
    //        "aggregationId": 0,
    //        "aggregationName": null
    //    },
    //    {
    //        "questionCode": "ASAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "No",
    //        "effectiveResponseCntRounded": 680,
    //        "sumQuestionEffectiveResponses": 2499,
    //        "customerResponseCnt": 74,
    //        "sumCustomerResponses": 340,
    //        "dateIndex": 5,
    //        "windowStart": "04/08/2024 00:00:00",
    //        "aggregationId": 0,
    //        "aggregationName": null
    //    },
    //    {
    //        "questionCode": "ASAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "Yes",
    //        "effectiveResponseCntRounded": 1820,
    //        "sumQuestionEffectiveResponses": 2499,
    //        "customerResponseCnt": 266,
    //        "sumCustomerResponses": 340,
    //        "dateIndex": 5,
    //        "windowStart": "04/08/2024 00:00:00",
    //        "aggregationId": 0,
    //        "aggregationName": null
    //    }
    //]

    //responseBreakdownOverTimeStats:
    //[

    //    //For Each aggregationName, finalResponse, for questionCode, for each dateIndex

    //    //DateIndex: 5

    //    //DateIndex: 5-CloseTicket

    //    //DateIndex: 5-CloseTicket-CSAT

    //    //DateIndex: 5-CloseTicket-CSAT-YES
    //    {
    //        "questionCode": "CSAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "Yes",
    //        "effectiveResponseCntRounded": 1,
    //        "sumQuestionEffectiveResponses": 3,
    //        "customerResponseCnt": 0,
    //        "sumCustomerResponses": 0,
    //        "dateIndex": 5,
    //        "windowStart": "04/08/2024 00:00:00",
    //        "aggregationId": 12,
    //        "aggregationName": "CloseTicket"
    //    },
    //    //DateIndex: 5-CloseTicket-CSAT-No
    //    {
    //        "questionCode": "CSAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "No",
    //        "effectiveResponseCntRounded": 2,
    //        "sumQuestionEffectiveResponses": 3,
    //        "customerResponseCnt": 0,
    //        "sumCustomerResponses": 0,
    //        "dateIndex": 5,
    //        "windowStart": "04/08/2024 00:00:00",
    //        "aggregationId": 12,
    //        "aggregationName": "CloseTicket"
    //    },

    //    //DateIndex: 5-CloseTicket-ASAT

    //    //DateIndex: 5-CloseTicket-ASAT-Yes
    //    {
    //        "questionCode": "ASAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "No",
    //        "effectiveResponseCntRounded": 1,
    //        "sumQuestionEffectiveResponses": 3,
    //        "customerResponseCnt": 0,
    //        "sumCustomerResponses": 0,
    //        "dateIndex": 5,
    //        "windowStart": "04/08/2024 00:00:00",
    //        "aggregationId": 12,
    //        "aggregationName": "CloseTicket"
    //    },
    //    //DateIndex: 5-CloseTicket-ASAT-No
    //    {
    //        "questionCode": "ASAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "Yes",
    //        "effectiveResponseCntRounded": 2,
    //        "sumQuestionEffectiveResponses": 3,
    //        "customerResponseCnt": 0,
    //        "sumCustomerResponses": 0,
    //        "dateIndex": 5,
    //        "windowStart": "04/08/2024 00:00:00",
    //        "aggregationId": 12,
    //        "aggregationName": "CloseTicket"
    //    },

    //    //DateIndex: 5-Callback

    //    {
    //        "questionCode": "CSAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "Yes",
    //        "effectiveResponseCntRounded": 31,
    //        "sumQuestionEffectiveResponses": 53,
    //        "customerResponseCnt": 5,
    //        "sumCustomerResponses": 8,
    //        "dateIndex": 5,
    //        "windowStart": "04/08/2024 00:00:00",
    //        "aggregationId": 11,
    //        "aggregationName": "Callback"
    //    },
    //    {
    //        "questionCode": "CSAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "No",
    //        "effectiveResponseCntRounded": 22,
    //        "sumQuestionEffectiveResponses": 53,
    //        "customerResponseCnt": 3,
    //        "sumCustomerResponses": 8,
    //        "dateIndex": 5,
    //        "windowStart": "04/08/2024 00:00:00",
    //        "aggregationId": 11,
    //        "aggregationName": "Callback"
    //    },
    //    {
    //        "questionCode": "ASAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "No",
    //        "effectiveResponseCntRounded": 14,
    //        "sumQuestionEffectiveResponses": 47,
    //        "customerResponseCnt": 1,
    //        "sumCustomerResponses": 7,
    //        "dateIndex": 5,
    //        "windowStart": "04/08/2024 00:00:00",
    //        "aggregationId": 11,
    //        "aggregationName": "Callback"
    //    },
    //    {
    //        "questionCode": "ASAT",
    //        "clientSpecificShortName": null,
    //        "finalResponse": "Yes",
    //        "effectiveResponseCntRounded": 34,
    //        "sumQuestionEffectiveResponses": 47,
    //        "customerResponseCnt": 6,
    //        "sumCustomerResponses": 7,
    //        "dateIndex": 5,
    //        "windowStart": "04/08/2024 00:00:00",
    //        "aggregationId": 11,
    //        "aggregationName": "Callback"
    //    },
    //]

    //ticketCountOverTimeByBreakdownStats:
    //For each dateIndex, for each breakdown item
    //[
    //    {
    //        "tickets": 12869,
    //        "agentSurveys": 680,
    //        "customerSurveys": 52,
    //        "compliance": 0,
    //        "dateIndex": 1,
    //        "windowStart": "03/11/2024 00:00:00",
    //        "aggregationId": -1,
    //        "aggregationName": "Unknown RFC"
    //    },
    //    {
    //        "tickets": 1080,
    //        "agentSurveys": 887,
    //        "customerSurveys": 149,
    //        "compliance": 0,
    //        "dateIndex": 1,
    //        "windowStart": "03/11/2024 00:00:00",
    //        "aggregationId": 1,
    //        "aggregationName": "connectivity"
    //    },

    //    //    //Dateindex 2
    //    {
    //        "tickets": 12884,
    //        "agentSurveys": 546,
    //        "customerSurveys": 37,
    //        "compliance": 0,
    //        "dateIndex": 2,
    //        "windowStart": "03/18/2024 00:00:00",
    //        "aggregationId": -1,
    //        "aggregationName": "Unknown RFC"
    //    },
    //    {
    //        "tickets": 1218,
    //        "agentSurveys": 986,
    //        "customerSurveys": 163,
    //        "compliance": 0,
    //        "dateIndex": 2,
    //        "windowStart": "03/18/2024 00:00:00",
    //        "aggregationId": 1,
    //        "aggregationName": "connectivity"
    //    },
    //]

    //domainValues
    //[
    //    {
    //        "domainId": 3,
    //        "domainName": "Division",
    //        "dimensionCode": "D",
    //        "domainValues": [
    //            {
    //                "domainId": 3,
    //                "domainValueId": 902,
    //                "domainValueName": "Account Management"
    //            },
    //            {
    //                "domainId": 3,
    //                "domainValueId": 901,
    //                "domainValueName": "Repair"
    //            }
    //        ]
    //    },
    //    {
    //        "domainId": 5,
    //        "domainName": "Site",
    //        "dimensionCode": "T",
    //        "domainValues": [
    //            {
    //                "domainId": 5,
    //                "domainValueId": 2001,
    //                "domainValueName": "BACOLOD"
    //            },
    //            {
    //                "domainId": 5,
    //                "domainValueId": 2002,
    //                "domainValueName": "ILOILO"
    //            }
    //        ]
    //    }
    //]
};

const handlers = {
    [SYSTEMDASHBOARDSCREEN_LOAD]: (state, action) => {
        if (action.error) {
            return { error: action.payload };
        }
        return { ...action.payload, dataLoaded: true }
    },
    [SYSTEMDASHBOARDSCREEN_UNLOAD]: () => initialState,
    [SYSTEMDASHBOARDSCREEN_SET]: (state, action) => action.updatedProps,
};

export default createReducer(initialState, handlers);
